import React from 'react';

import { PERMISSIONS, PermissionsContext } from 'contexts/PermissionsContext';
import ContextualMenu from 'Details/ContextualMenu';

import { HighlightBlock, HighlightBlockWrapper } from './WaterfallChart.styles';
import { useContext } from 'react';

const DISABLED_CATEGORIES = ['Sourceable', 'Non Sourceable'];

export const HighlightBlockComponent = props => {
	const {
		left,
		width,
		height,
		grouppedItemIndex,
		categories = [],
		isTailSpend,
		isWaterfall,
		onTopVendorsClick,
		onViewTransactionsClick,
		onChangeStatusClick,
		onMoveToBinClick,
		onSetTargetClick,
		onItemClick,
		hideContextualMenu,
		hideIndex,
		highlightedIndex,
		className,
		onOut,
		menuOpenIndex,
		setMenuOpenIndex,
	} = props;
	const { permissions } = useContext(PermissionsContext);

	const hasWritePermissions =
		permissions && permissions.includes(PERMISSIONS.TransactionsWrite);
	const hasTrackPermissions =
		permissions && permissions.includes(PERMISSIONS.TrackingWrite);

	const itemWidth = width / categories.length;

	const shouldHideMenuItemAt = index => {
		return Array.isArray(grouppedItemIndex)
			? grouppedItemIndex.includes(index)
			: index === grouppedItemIndex;
	};
	const mapCategories = isWaterfall ? [...categories].reverse() : categories;
	const isTailSpendColumn = cat => cat === 'Tail spend';

	return (
		<HighlightBlockWrapper
			left={left}
			width={width}
			height={height}
			isActive={!menuOpenIndex}
			className={className}
			onMouseOut={onOut}
		>
			{mapCategories &&
				mapCategories.map(
					(category, index) =>
						hideIndex !== index && !DISABLED_CATEGORIES.includes(category) ? (
							<HighlightBlock
								isHighlight={index === highlightedIndex}
								key={index}
								width={itemWidth}
								left={index * itemWidth}
								onClick={() => onItemClick(index, category)}
								isActive={menuOpenIndex === index}
							>
								{!hideContextualMenu &&
									!shouldHideMenuItemAt(index) && (
										<ContextualMenu
											onViewTransactions={() => onViewTransactionsClick(index)}
											onShowTopVendors={() => onTopVendorsClick(index)}
											onChangeStatus={
												!isTailSpend &&
												!isTailSpendColumn(category) &&
												(() => onChangeStatusClick(index))}
											setTarget={
												!isTailSpend &&
												!isTailSpendColumn(category) &&
												onSetTargetClick &&
												(() => onSetTargetClick(index))
											}
											moveToBin={
												!isTailSpend &&
												!isTailSpendColumn(category) &&
												(() => onMoveToBinClick(index))
											}
											hasWritePermissions={hasWritePermissions}
											hasTrackPermissions={hasTrackPermissions}
											toggleMenu={isOpen =>
												setMenuOpenIndex(isOpen ? index : null)
											}
											isOpen={menuOpenIndex === index}
										/>
									)}
							</HighlightBlock>
						) : null
				)}
		</HighlightBlockWrapper>
	);
};

export default HighlightBlockComponent;
